"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = void 0;
const config_1 = require("./services/config");
const subscriptions_1 = require("./subscriptions");
const subscriptions = {};
const handleCustomSubscriptions = (config) => {
    [
        ['info', 'onInfo'],
        ['warn', 'onWarn'],
        ['error', 'onError'],
    ].forEach((i) => {
        const level = i[0];
        const fnName = i[1];
        if (typeof config[fnName] === 'function') {
            if (subscriptions[fnName])
                (0, subscriptions_1.unsubscribe)(subscriptions[fnName]);
            subscriptions[fnName] = (0, subscriptions_1.subscribe)(`${level}:*`, config[fnName]);
        }
    });
};
const handleDefaultSubscriptions = (config) => {
    [
        ['info', 'logInfo'],
        ['warn', 'logWarn'],
        ['error', 'logError'],
    ].forEach((i) => {
        const level = i[0];
        const fnName = i[1];
        if (config[fnName] === true) {
            if (subscriptions[fnName])
                (0, subscriptions_1.unsubscribe)(subscriptions[fnName]);
            subscriptions[fnName] = (0, subscriptions_1.subscribe)(`${level}:*`, function (m) {
                console[level]('[ctc]', m.type, m.code, m.payload || {});
            });
        }
    });
};
const init = (config) => {
    if (typeof config !== 'object')
        throw new Error('Bad config, please review docs');
    if (typeof config.checkoutConfig === 'object')
        (0, config_1.updateCheckoutConfig)(config.checkoutConfig);
    handleCustomSubscriptions(config);
    handleDefaultSubscriptions(config);
};
exports.init = init;
//# sourceMappingURL=init.js.map